/* lkp2-19.js - Parker pens look exactly like penspersonalised.co.uk (20/10/2026). Loads after lkp2-18.js.
   1) Preview photos as on Pens: one shared silver clip photo for the coloured pens (no tinting),
      the Pens Gold photo for gold and the Pens Silver & Gold photo for silver & gold (set per colour in lush.lkp2).
   2) Engraving text and the "Your text" placeholder are solid, crisp black (no faint / italic sample on pens).
   3) Colour swatches sit on the page under the price, before the Personalise button, like the Pens Jotter page
      (same 8 colours, order, size and labels); the colour choice is no longer repeated inside the pop-up.
   Other lkp2 products are untouched (everything below only runs for the lk-pen-preview photos). */
(function () {
  'use strict';
  var K = window.__lkp2k, P = K && K.P;
  if (!P || P.prototype._lkPen19) return;
  P.prototype._lkPen19 = 1;
  var lc = K.lc || function (s) { return String(s == null ? '' : s).toLowerCase().trim(); };
  var PENRE = /lk-pen-preview/;

  function isPen(m) {
    var c = m && m.cfg; if (!c || !c.faces) return false;
    return c.faces.some(function (f) { var ps = f && f.photos; return !!ps && Object.keys(ps).some(function (k) { return ps[k] && PENRE.test(ps[k].img || ''); }); });
  }

  /* same list, order and colours as blocks/jotter-color-swatches.liquid */
  var SW = [
    { n: 'Silver', t: 'Stainless Steel Chrome', c: '#C7CBCF', h: 'parker-jotter-stainless-steel-chrome-trim-ballpoint-pen' },
    { n: 'Silver & Gold', t: 'Stainless Steel Gold Trim', c: '#C9B27C', h: 'parker-jotter-stainless-steel-gold-trim-ballpoint-pen' },
    { n: 'Gold', t: 'Gold', c: '#B8934A', h: 'parker-jotter-xl-monochrome-gold-ballpoint-pen' },
    { n: 'Blue', t: 'Royal Blue', c: '#1F4E9C', h: 'parker-jotter-royal-blue-ballpoint-pen' },
    { n: 'Black', t: 'Original Black', c: '#1C1C1C', h: 'parker-jotter-original-black-ballpoint-pen' },
    { n: 'Red', t: 'Kensington Red', c: '#A8232F', h: 'parker-jotter-kensington-red-ballpoint-pen' },
    { n: 'Purple', t: 'Victoria Violet', c: '#5B3F9E', h: 'parker-jotter-victoria-violet-ballpoint-pen' },
    { n: 'Pink', t: 'Original Pink', c: '#D63A8E', h: 'parker-jotter-original-pink-ballpoint-pen' }
  ];
  var ALL = SW.map(function (s) { return s.n; });
  /* single-colour pens: which swatch is this page */
  var ONE = { 'personalised-engraved-gold-parker-pen': 'Gold', 'personalised-engraved-blue-parker-pen': 'Black', 'personalised-engraved-blue-parker-pen-1': 'Blue' };
  /* pen with a Colour variant option: swatch name -> variant value */
  var VAR = { 'Silver': 'Silver', 'Silver & Gold': 'Gold' };

  /* ---------- 1) Pens photo structure: no tint, Pens framing, solid black ink ---------- */
  var oPL = P.prototype.photoList;
  P.prototype.photoList = function () {
    var l = oPL.apply(this, arguments);
    (l || []).forEach(function (ph) {
      if (!ph || !PENRE.test(ph.src || ph.img || '')) return;
      if (ph.tint) { delete ph.tint; ph.view = { x: 49, y: 52, zoom: 1.6 }; }
      ph.ink = '#000000';
    });
    return l;
  };

  /* Pens framing: the photo zoomed onto the barrel point (47%, 53%), 1.35x on desktop and 1.9x on phones
     (same numbers as .pen-personaliser__scene in assets/pp-engrave-fix.css). */
  var oVR = P.prototype.viewRect;
  P.prototype.viewRect = function (ph, W, H, A, mode) {
    if (!ph || !ph.pens || mode === 'full' || mode === 'close') return oVR.apply(this, arguments);
    var zm = (window.innerWidth || 1000) <= 900 ? 1.9 : 1.35, sw = W / zm, sh = sw / A;
    return { x: 0.47 * W - sw / 2, y: 0.53 * H - sh / 2, w: sw, h: sh };
  };

  /* ---------- 2) placeholder "Your text" solid black, like Pens ---------- */
  var oPlan = P.prototype.plan;
  P.prototype.plan = function (f, ph) {
    var r = oPlan.apply(this, arguments);
    if (r && ph && ph.pens && r.ghost && !this._lkPlain) r.ghost = false;
    return r;
  };

  /* ---------- 3) colour swatches on the page ---------- */
  function mode(m) {
    var h = m.product && m.product.handle;
    if (m.colourIsVariant) return 'var';
    if (m.cfg.colours && m.cfg.colours.length) return 'cfg';
    if (ONE[h]) return 'one';
    return null;
  }
  function colIdx(m) { return m.optIndex ? m.optIndex.colour : null; }
  function current(m, md) {
    if (md === 'cfg') return m.st.colour;
    if (md === 'one') return ONE[m.product.handle];
    var i = colIdx(m), v = m.variant && m.variant.o ? m.variant.o[i] : null, hit = null;
    Object.keys(VAR).forEach(function (k) { if (VAR[k] === v) hit = k; });
    return hit;
  }
  function inPage(md, n) { return md === 'cfg' || (md === 'var' && VAR[n] != null); }

  function build(m) {
    if (m._lkSw19 || !isPen(m)) return;
    var md = mode(m); if (!md) return;
    var host = m.host || m.root, launch = host && host.querySelector('.lkp2__launch'), go = launch && launch.querySelector('.lkp2__go');
    if (!go) return;
    m._lkSw19 = 1;
    if (md === 'cfg') { m.cfg.colours = ALL.slice(); if (!m.st.colour || ALL.indexOf(m.st.colour) < 0) m.st.colour = 'Silver'; }
    var wrap = document.createElement('div');
    wrap.className = 'pp-jotter-swatches lk-pen-sw';
    var row = '';
    SW.forEach(function (s) {
      var dot = '<span class="pp-jotter-swatch__dot" style="background-color:' + s.c + ';"></span>';
      if (inPage(md, s.n)) row += '<button type="button" class="pp-jotter-swatch" data-lksw="' + s.n + '" title="' + s.t + '" aria-label="' + s.t + '" aria-pressed="false">' + dot + '</button>';
      else if (md === 'one' && ONE[m.product.handle] === s.n) row += '<span class="pp-jotter-swatch is-selected" title="' + s.t + '" aria-label="' + s.t + ' (this pen)">' + dot + '</span>';
      else row += '<a href="/products/' + s.h + '" class="pp-jotter-swatch" title="' + s.t + '" aria-label="' + s.t + '">' + dot + '</a>';
    });
    wrap.innerHTML = '<p class="pp-jotter-swatches__label"><span>Colour: <strong data-lkswname></strong></span><span class="pp-ink"><span class="pp-ink__dot" aria-hidden="true"></span>Ink Colour: <strong>Black</strong></span></p><div class="pp-jotter-swatches__row" role="group" aria-label="Colour">' + row + '</div>';
    launch.insertBefore(wrap, go);
    m._lkSwEl = wrap;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lksw]'); if (!b) return;
      e.preventDefault();
      var n = b.getAttribute('data-lksw');
      if (md === 'cfg') { m.st.colour = n; m.sync(); try { m.drawStage(); } catch (x) {} return; }
      if (md === 'var') {
        var i = colIdx(m), v = m.xoMatch ? m.xoMatch(i, VAR[n]) : null;
        if (!v || (m.variant && m.variant.id === v.id) || m._xoBusy) return;
        m._xoBusy = true;
        m.selectVariant(v.id, function () { m._xoBusy = false; try { m.xoSync(); m.renderSteps(); } catch (x) {} paint(m); });
      }
    });
    hidePopupColour(m, md);
    paint(m);
  }

  function paint(m) {
    var w = m._lkSwEl; if (!w) return;
    var md = mode(m), cur = current(m, md);
    w.querySelectorAll('[data-lksw]').forEach(function (b) {
      var on = lc(b.getAttribute('data-lksw')) === lc(cur);
      b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on));
    });
    var nm = w.querySelector('[data-lkswname]'); if (nm) nm.textContent = cur || '';
  }

  function hidePopupColour(m, md) {
    var r = m.root; if (!r) return;
    if (md === 'cfg') r.querySelectorAll('.lkp2__colours').forEach(function (el) { el.classList.add('lk-pen-hide'); });
    if (md === 'var' && m.elXo) { var g = m.elXo.querySelector('[data-xo="' + colIdx(m) + '"]'); if (g) g.classList.add('lk-pen-hide'); }
  }

  var oSync = P.prototype.sync;
  P.prototype.sync = function () {
    var r = oSync.apply(this, arguments);
    if (this._lkSw19) { paint(this); hidePopupColour(this, mode(this)); }
    return r;
  };

  /* Review: the colour is chosen on the page now, so no "Edit" back into the pop-up for it */
  var oSum = P.prototype.renderSummary;
  P.prototype.renderSummary = function () {
    var r = oSum.apply(this, arguments);
    if (this._lkSw19 && this.elSummary) this.elSummary.querySelectorAll('li').forEach(function (li) {
      var a = li.querySelector('.lkp2__sface'), b = li.querySelector('[data-step="finish"]');
      if (a && b && lc(a.textContent) === 'colour') b.parentNode.removeChild(b);
    });
    return r;
  };

  var css = document.createElement('style');
  css.textContent = [
    '.lk-pen-hide{display:none!important}',
    '.lkp2__launch .lk-pen-sw{flex:1 1 100%;width:100%;margin:4px 0 14px}',
    '.lk-pen-sw .pp-jotter-swatches__label{font-size:13px;color:#5C534A;margin:0 0 10px;display:flex;flex-wrap:wrap;align-items:center;gap:4px 18px;line-height:1.4}',
    '.lk-pen-sw .pp-jotter-swatches__label strong{color:#2C2825}',
    '.lk-pen-sw .pp-ink{display:inline-flex;align-items:center;gap:6px}',
    '.lk-pen-sw .pp-ink__dot{width:10px;height:10px;border-radius:50%;background:#111;display:inline-block}',
    '.lk-pen-sw .pp-jotter-swatches__row{display:flex;flex-wrap:wrap;gap:12px}',
    '.lk-pen-sw .pp-jotter-swatch{display:block;width:44px;height:44px;border-radius:50%;padding:3px;box-sizing:border-box;border:2px solid transparent;background:none;cursor:pointer;transition:border-color .15s;margin:0;min-width:0;min-height:0;box-shadow:none}',
    '.lk-pen-sw .pp-jotter-swatch:hover{border-color:#D4B06A}',
    '.lk-pen-sw .pp-jotter-swatch.is-selected{border-color:#9C7A3C}',
    '.lk-pen-sw .pp-jotter-swatch__dot{display:block;width:100%;height:100%;border-radius:50%;border:1px solid rgba(0,0,0,0.18);box-sizing:border-box}'
  ].join('');
  document.head.appendChild(css);

  function run() {
    document.querySelectorAll('[data-lkp2]').forEach(function (el) {
      var m = el.__lkp2; if (!m || !m.cfg || !isPen(m)) return;
      try { build(m); if (!m._lkR19) { m._lkR19 = 1; m._sig = null; m.sync(); m.drawStage(); } } catch (e) {}
    });
  }
  run(); setTimeout(run, 800); setTimeout(run, 2000);
})();
